import React from "react";
import { Link } from "react-router-dom";
import { Stack } from "react-bootstrap";

const NavigasiBar = () => {
    return(
        <Stack className="card p-5 mt-3 mb-5">
            <Link to="/">
                <button className="me-5 w-100 btn btn-primary">Home</button>
            </Link>
            <Stack gap={3} className="d-flex flex-row justify-content-start align-self-center mt-5">
            <Link className="me-5" to="/animal-page">
                <button className="btn btn-primary">Animal Page</button>
            </Link>
            <Link to="/form-page">
                <button className="me-5 btn btn-primary">Form Page</button>
            </Link>
            <Link to="/read-article">
                <button className="me-5 btn btn-info">Read Article</button>
            </Link>
            <Link to="/create-article">
                <button className="me-5 btn btn-primary">Create Article</button>
            </Link>
            <Link to="/delete-article">
                <button className="me-5 btn btn-primary">Delete Article</button>
            </Link>
            </Stack>
        </Stack>
    );
} 

export default NavigasiBar;